/**
 * The published ROWA reference profile: the guideline values a portfolio is
 * read against. The Overview health fallback scores against them, its
 * methodology dialog quotes them, and Risk & liquidity draws them as
 * reference lines beside the outcome figures (drawdown, concentration).
 * Shared here because both features read the same numbers.
 */
export const HEALTH_REFERENCE = {
  /** Largest look-through asset should stay under 35% (breach at 50%). */
  largestAssetReferenceBps: 3500,
  largestAssetBreachBps: 5000,
  /** Largest single-vault allocation reference and breach. */
  vaultAllocationReferenceBps: 4500,
  vaultAllocationBreachBps: 6000,
  /** Minimum effective holdings (1 / Herfindahl) before a watch state. */
  effectiveHoldingsReference: 4,
  /** Pricing coverage below this share of exposure is a watch state. */
  dataCoverageWatchBps: 9000,
  /** Cash above this share of portfolio value reads as idle capital. */
  idleReserveShare: 0.05,
  idleWatchShare: 0.15,
  idleFloorShare: 0.35,
  /**
   * Max drawdown reference (5%) and floor (10%). Reference lines for the
   * drawdown the Risk page shows as an outcome; not a health score input.
   */
  drawdownReferenceBps: 500,
  drawdownFloorBps: 1000,
  /** At least 15% of covered value should be exitable within one day. */
  oneDayLiquidityReferenceBps: 1500,
  oneDayLiquiditySoundBps: 4000,
  /** Publication gates, in weight basis points. */
  minCoverageBps: 6000,
  provisionalCoverageBps: 8000
} as const;
